/**
 * ONE gender normaliser. Stored patient rows, appointment rows and ABHA/ABDM data carry
 * legacy short codes ("M"/"F"/"O") or mixed case ("Male"); the backend request schemas want
 * MALE | FEMALE | OTHER. Every place that pre-fills a gender form field or sends `gender`
 * goes through normalizeGender — whether or not ABDM is switched on for the organisation.
 */
export const ABHA_GENDER_TO_FORM = { M: 'MALE', F: 'FEMALE', O: 'OTHER' };

const CANONICAL = ['MALE', 'FEMALE', 'OTHER'];

/** 'M' | 'm' | 'Male' | ' MALE ' -> 'MALE'; empty / unrecognised -> ''. */
export function normalizeGender(raw) {
  const val = String(raw || '').trim().toUpperCase();
  if (CANONICAL.includes(val)) return val;
  return ABHA_GENDER_TO_FORM[val] || '';
}
